import { render, staticRenderFns } from "./StationSummaryContent.vue?vue&type=template&id=13bc71d8&scoped=true"
import script from "./StationSummaryContent.vue?vue&type=script&lang=ts"
export * from "./StationSummaryContent.vue?vue&type=script&lang=ts"
import style0 from "./StationSummaryContent.vue?vue&type=style&index=0&id=13bc71d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bc71d8",
  null
  
)

export default component.exports